import(/* webpackMode: "eager" */ "/app/apps/web-app/public/svg/empty_state.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web-app/src/components/authBlock/AuthBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/app/apps/web-app/src/components/icon/Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web-app/src/components/layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
